import { render, staticRenderFns } from "./DashboardGestaoKpis.vue?vue&type=template&id=69f7397c&scoped=true"
import script from "./DashboardGestaoKpis.vue?vue&type=script&lang=js"
export * from "./DashboardGestaoKpis.vue?vue&type=script&lang=js"
import style0 from "./DashboardGestaoKpis.vue?vue&type=style&index=0&id=69f7397c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69f7397c",
  null
  
)

export default component.exports